import { render, staticRenderFns } from "./AdminEvent.vue?vue&type=template&id=51a2f7d0&scoped=true&"
import script from "./AdminEvent.vue?vue&type=script&lang=js&"
export * from "./AdminEvent.vue?vue&type=script&lang=js&"
import style0 from "./AdminEvent.vue?vue&type=style&index=0&id=51a2f7d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2f7d0",
  null
  
)

export default component.exports